import { ChatCircle } from "@phosphor-icons/react";
import { formatDate } from "./shared";

/* ============================================================================
 * FeedbackInbox — user-submitted feedback from /feedback page.
 * ==========================================================================*/
export function FeedbackInbox({ feedback, onMarkRead }) {
  const { unread = 0, items = [] } = feedback || {};

  return (
    <section
      className="border border-white/10 bg-[#0a0a0a] p-6"
      data-testid="admin-feedback"
    >
      <div className="flex items-baseline justify-between mb-5 gap-3">
        <div className="flex items-center gap-3">
          <ChatCircle size={18} weight="duotone" className="text-[#FF2A2A]" />
          <div>
            <div className="font-mono text-[10px] uppercase tracking-[0.28em] text-[#FF2A2A] mb-1">
              // user feedback
            </div>
            <h3 className="font-display text-xl font-extrabold tracking-tight">
              Inbox
              {unread > 0 && (
                <span className="ml-3 inline-flex items-center justify-center text-xs font-mono bg-[#FF2A2A] text-white px-2 py-0.5">
                  {unread} new
                </span>
              )}
            </h3>
          </div>
        </div>
        <span className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/45">
          from /feedback
        </span>
      </div>

      {items.length === 0 ? (
        <p className="font-mono text-[10px] uppercase tracking-[0.22em] text-white/30">
          no feedback yet · share stableish.me/feedback to collect it
        </p>
      ) : (
        <ul className="space-y-3 max-h-[420px] overflow-y-auto pr-2">
          {items.map((item) => (
            <li
              key={item.id}
              data-testid={`feedback-item-${item.id}`}
              className={`border p-4 ${item.read ? "border-white/10 bg-black" : "border-[#FF2A2A]/40 bg-[#FF2A2A]/[0.04]"}`}
            >
              <div className="flex items-baseline justify-between gap-3 mb-2">
                <div className="flex items-baseline gap-2 min-w-0">
                  <span className="font-mono text-[10px] uppercase tracking-[0.2em] text-white/85 truncate">
                    {item.name || "anonymous"}
                  </span>
                  {item.email && (
                    <a
                      href={`mailto:${item.email}?subject=Re: your Stable-ish feedback`}
                      className="text-xs text-[#FF2A2A] hover:underline truncate"
                    >
                      {item.email}
                    </a>
                  )}
                </div>
                <span className="font-mono text-[9px] uppercase tracking-[0.18em] text-white/40 shrink-0">
                  {formatDate(item.created_at)}
                </span>
              </div>
              <p className="text-sm text-white/80 leading-relaxed whitespace-pre-wrap">
                {item.message}
              </p>
              {!item.read && (
                <button
                  onClick={() => onMarkRead(item.id)}
                  data-testid={`feedback-mark-read-${item.id}`}
                  className="mt-3 font-mono text-[10px] uppercase tracking-[0.22em] text-white/50 hover:text-[#FF2A2A]"
                >
                  Mark as read →
                </button>
              )}
            </li>
          ))}
        </ul>
      )}
    </section>
  );
}
